import { get } from 'lodash';

export const dataGridTextSorter =
  (dataIndex, transform = (v) => v) =>
  (a, b) => {
    const dataItemA = transform(get(a, dataIndex));
    const dataItemB = transform(get(b, dataIndex));

    return dataItemA === null || dataItemB === null
      ? 0
      : dataItemA.localeCompare(dataItemB);
  };

export const dataGridSurnameSorter = (dataIndex) => (a, b) => {
  const getSortableName = (fullName) => {
    if (!fullName || typeof fullName !== 'string') {
      return '';
    }

    const words = fullName.split(' ').filter(Boolean);

    if (words.length === 0) {
      return '';
    }

    const firstRealNameIndex = words.findIndex((word) => !word.includes('.'));

    //added ~ so if there is such string, it will be always on buttom but still sorted with similiar strings )
    if (firstRealNameIndex === -1) {
      return '~' + fullName;
    }

    const realNameParts = words.slice(firstRealNameIndex);

    return realNameParts.join('');
  };

  const nameA = get(a, dataIndex);
  const nameB = get(b, dataIndex);

  const sortableNameA = getSortableName(nameA);
  const sortableNameB = getSortableName(nameB);

  return sortableNameA.localeCompare(sortableNameB);
};

export const dataGridDateSorter = (dataIndex) => (a, b) => {
  const dataItemA = get(a, dataIndex);
  const dataItemB = get(b, dataIndex);

  if (dataItemA === null || dataItemB === null) {
    return dataItemA === dataItemB ? 0 : dataItemA === null ? -1 : 1; //if one of the values is empty and the other is not, assume the bigger value is non-empty one
  }

  return new Date(dataItemA).getTime() - new Date(dataItemB).getTime();
};

export const dataGridNumberSorter =
  (dataIndex, transform = (v) => v) =>
  (a, b) => {
    const dataItemA = transform(get(a, dataIndex));
    const dataItemB = transform(get(b, dataIndex));

    if (dataItemA === null || dataItemB === null) {
      return 0;
    }

    return dataItemA < dataItemB ? -1 : dataItemA > dataItemB ? 1 : 0;
  };
